import AmexMarketingEditorialsCard from './AmexMarketingEditorialsCard';

export default AmexMarketingEditorialsCard;
